import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import CounterCard from '../../../../../components/Molecules/Card/CounterCard/CounterCard';
import styleClasses from '../../../../../components/Molecules/Card/CounterCard/counterCard.module.scss';
import SelectCard from '../../../../../components/Molecules/Card/SelectCard/SelectCard';
import { ICoreModifiersComponent } from '../../../../../models/try2Combo';
import * as Constants from '../../../../../constants';
import { verifyStatus } from '../../../../../helpers/customizedItem/customizedItem.helper';
import { Accordion } from 'react-bootstrap';

const CoreModifiers: React.FC<ICoreModifiersComponent> = (props) => {
  const {
    coreModifiers,
    selectedCore,
    handleCoreModifierClick,
    isLimitExceed,
    openFirstAccordion,
  } = props;

  const [openAccordions, setOpenAccordions] = React.useState<string[]>(
    openFirstAccordion ? ['0'] : []
  );

  const handleToggle = (id: string): void => {
    const indexOfCurrentId: number = openAccordions.indexOf(id);
    const newData: string[] = [...openAccordions];
    if (indexOfCurrentId === -1) {
      newData.push(id);
      setOpenAccordions(newData);
    } else {
      newData.splice(indexOfCurrentId, 1);
      setOpenAccordions(newData);
    }
  };

  const selectedCoreModifier = (modifier) => {
    return selectedCore.find(
      (selected) => selected.modifier_id === modifier.id
    );
  };

  return (
    <Container fluid>
      <Accordion
        activeKey={openAccordions}
        className="modifiers-accordions-wrapper"
      >
        <Accordion.Item eventKey="0">
          <Accordion.Header onClick={() => handleToggle('0')}>
            <span className="d-block text-capitalize f-sm-s18">
              Add or remove ingredients
            </span>
          </Accordion.Header>
          <Accordion.Body>
            <Row className={`${styleClasses.try2_all_dressing}`}>
              {coreModifiers &&
                coreModifiers.map((modifier) => {
                  const selected = selectedCoreModifier(modifier);
                  return (
                    <Col xs="4" sm="3" className="py-md-3" key={modifier?.id}>
                      {modifier?.max > 1 ? (
                        <CounterCard
                          id={modifier?.id}
                          brink_id={modifier?.brink_modifier_id}
                          image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                          title={modifier.name}
                          price={modifier.price}
                          calories={modifier.calories}
                          max={modifier.max}
                          groupMin={modifier.modifier_group_min}
                          is_active={verifyStatus(
                            modifier,
                            Constants.MODIFIER_LOCATION
                          )}
                          handleClick={(data) => {
                            handleCoreModifierClick(
                              {
                                ...data,
                                ...{
                                  brink_modifier_group_id:
                                    modifier?.brink_modifier_group_id,
                                  brink_modifier_id:
                                    modifier?.brink_modifier_id,
                                  core: true,
                                },
                              },
                              modifier,
                              Constants.CORE_MODIFIERS
                            );
                          }}
                          count={selected?.quantity || 0}
                          from={Constants.TRY_2_COMBO}
                          priceAlternateLabel={
                            selected?.quantity ? 'included' : 'include'
                          }
                          modifierType={'core_modifier'}
                          additionalPrice={selected?.additionalPrice}
                          extendableLimit={isLimitExceed(
                            modifier?.modifier_group_id,
                            modifier?.modifier_group_extendable_limit,
                            modifier.modifier_group_min
                          )}
                          extendableLimitValue={
                            modifier?.modifier_group_extendable_limit
                          }
                        />
                      ) : (
                        <SelectCard
                          id={modifier?.id}
                          brink_id={modifier?.brink_modifier_id}
                          default_selected={
                            modifier.is_selected ? modifier.is_selected : 1
                          }
                          image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier.image}`}
                          title={modifier.name}
                          price={modifier.price}
                          calories={modifier.calories}
                          groupMin={modifier.modifier_group_min}
                          is_active={verifyStatus(
                            modifier,
                            Constants.MODIFIER_LOCATION
                          )}
                          handleClick={(data) => {
                            handleCoreModifierClick(
                              {
                                ...data,
                                ...{
                                  brink_modifier_group_id:
                                    modifier?.brink_modifier_group_id,
                                  brink_modifier_id:
                                    modifier?.brink_modifier_id,
                                  core: true,
                                },
                              },
                              modifier,
                              Constants.CORE_MODIFIERS
                            );
                          }}
                          priceAlternateLabel={
                            selected?.quantity ? 'included' : 'include'
                          }
                          selected={Boolean(selected)}
                          modifierAdditionalPrice={selected?.additionalPrice}
                          componentUsedIn={Constants.TRY_2_COMBO}
                          extendableLimit={isLimitExceed(
                            modifier?.modifier_group_id,
                            modifier?.modifier_group_extendable_limit,
                            modifier.modifier_group_min
                          )}
                          extendableLimitValue={
                            modifier?.modifier_group_extendable_limit
                          }
                        />
                      )}
                    </Col>
                  );
                })}
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default CoreModifiers;
